import { render, staticRenderFns } from "./TabelaFormularioEnderecos.vue?vue&type=template&id=274564fd&"
import script from "./TabelaFormularioEnderecos.vue?vue&type=script&lang=js&"
export * from "./TabelaFormularioEnderecos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports